import { ProductType } from 'types/product.types';

import { PRODUCTS_ADD } from '../action-types/home-page.action-types';

export type HomePageReducer = {
  products: ProductType[];
};

const initialState: HomePageReducer = {
  products: [],
};

const homePageReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCTS_ADD: {
      return {
        ...state,
        products: action.data,
      };
    }
    default: {
      return state;
    }
  }
};

export default homePageReducer;
